/**
 * Instruction from mui doc
 * ==============================
 * Ref: https://mui.com/material-ui/customization/theming/
 * Theme composition: using theme options to define other options
 * When the value for a theme option is dependent on another theme option, you should compose the theme in steps.
 */

export const venueKioskVUIThemeOptionFactory = (theme) => ({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "uppercase",
        },
        sizeSmall: {
          fontSize: 20,
          padding: theme.spacing(1, 2.5),
        },
        sizeMedium: {
          fontSize: 22,
          padding: theme.spacing(1.5, 4),
        },
        sizeLarge: {
          fontSize: 24,
          padding: theme.spacing(2, 5),
        },
      },
    },
    MuiFab: {
      styleOverrides: {
        sizeLarge: {
          padding: theme.spacing(5, 6),
          "& .MuiSvgIcon-root": {
            width: 40,
            height: 40,
          },
        },
      },
    },

    /**
     * VenueUI (Vui) - Vertical Kiosk
     * Extra Component for venue.in.th projects
     */
    VuiSearchBasePopup: {
      styleOverrides: {
        dialog: {
          "& .MuiPaper-root": {
            marginBottom: theme.spacing(40),
          },
        },
      },
    },
    VuiSearchPopupContent: {
      styleOverrides: {
        root: {
          backgroundColor: "transparent",
        },
      },
    },
    VuiDetailCard: {
      styleOverrides: {
        image: {
          width: "50%",
          margin: "0 auto",
          [theme.breakpoints.up("sm")]: {
            width: "50%",
            margin: "0 auto",
          },
        },
        infoListItem: {},
      },
    },
  },
})
